// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"44762171","242":"79d97356","304":"d0cf868e","466":"0a80ca37","648":"a145d216","658":"c4cb0e94","775":"fdd133ce","793":"d49d3c3e","840":"4102729a","845":"c8d17aba"}[chunkId] + ".chunk.js";
};